module.exports = __webpack_public_path__ + "img/index-cz-icon.b5db0055.png";